import React from "react";
import MiraiHomeHero from "./mirai-home/MiraiHomeHero";
import HomeSupport from "./mirai-home/HomeSupport";
import HomeNews from "./mirai-home/HomeNews";
import HomeGlobal from "./mirai-home/HomeGlobal";
import HomeSlider from "./mirai-home/HomeSlider";
import HomeGoogleMapGlobal from "./mirai-home/HomeGoogleMapGlobal";
import HomeSupportTwo from "./mirai-home/HomeSupportTwo";
import HomeServices from "./mirai-home/HomeServices";
import WhatWeDo from "./Login/MiraiAllPage/MiraiHomeTwo/WhatWeDo";
import HomeGlobalThree from "./mirai-home/HomeGlobalThree";
import HomeNewsUpdate from "./mirai-home/HomeNewsUpdate";
import HomeSliderUpdate from "./mirai-home/HomeSliderUpdate";
import "./home.css";
import CombinedUpdates from "./mirai-home/CombinedUpdates";

const HomeAll = () => {
  return (
    <div>
      <MiraiHomeHero />
      <HomeSupportTwo />
      <CombinedUpdates></CombinedUpdates>
    </div>
  );
};

export default HomeAll;
